import { Injectable } from '@angular/core';
import { CanMatch } from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';

/**
 * Session Guard for protecting routes that require authentication.
 *
 * This guard uses the SessionService's loggedIn$ observable to determine
 * if the user is authenticated. If not authenticated, the SessionService
 * will handle the redirect to the login page.
 *
 * Usage in routes:
 * ```typescript
 * {
 *   path: 'protected-route',
 *   loadChildren: () => import('./module').then(m => m.Module),
 *   canMatch: [SessionGuard]
 * }
 * ```
 */
@Injectable()
export class SessionGuard implements CanMatch {
  constructor(private session: SessionService) {}

  /**
   * Determines if the route can be matched based on login status.
   * Returns an observable that emits true when user is logged in.
   */
  canMatch(): Observable<boolean> {
    return this.session.loggedIn$;
  }
}
